import { apiClient } from '../apiClient';
import {
  ProviderDto,
  CreateProviderDto,
  UpdateProviderDto,
  TestConnectionResultDto,
} from '@shared/contracts';

export const providersApi = {
  list: (): Promise<ProviderDto[]> => {
    return apiClient.get<ProviderDto[]>('/providers');
  },

  listActive: (): Promise<ProviderDto[]> => {
    return apiClient.get<ProviderDto[]>('/providers/active');
  },

  getById: (id: string): Promise<ProviderDto> => {
    return apiClient.get<ProviderDto>(`/providers/${id}`);
  },

  create: (payload: CreateProviderDto): Promise<ProviderDto> => {
    return apiClient.post<ProviderDto>('/providers', payload);
  },

  update: (id: string, payload: UpdateProviderDto): Promise<ProviderDto> => {
    return apiClient.put<ProviderDto>(`/providers/${id}`, payload);
  },

  delete: (id: string): Promise<{ success: boolean; message: string }> => {
    return apiClient.delete<{ success: boolean; message: string }>(`/providers/${id}`);
  },

  testConnection: (id: string): Promise<TestConnectionResultDto> => {
    return apiClient.post<TestConnectionResultDto>(`/providers/${id}/test`);
  },
};
